import apiGroupsAthletes from '@/api/groups-athletes'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getGroupsAthletesStart: '[groups athletes] Get groups athletes start',
  getGroupsAthletesSuccess: '[groups athletes] Get groups athletes success',
  getGroupsAthletesFailure: '[groups athletes] Get groups athletes failure'
}

export const actionTypes = {
  getGroupsAthletes: '[groups athletes] Get groups athletes'
}

const mutations = {
  [mutationTypes.getGroupsAthletesStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getGroupsAthletesSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getGroupsAthletesFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.getGroupsAthletes](context, {groupId}) {
    context.commit(mutationTypes.getGroupsAthletesStart)
    return new Promise(resolve => {
      apiGroupsAthletes
        .getGroupsAthletes(groupId)
        .then(response => {
          context.commit(mutationTypes.getGroupsAthletesSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getGroupsAthletesFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
